import { useStoreSystem } from "../store";
import { Utils } from "../utils/utils";
import shallow from "zustand/shallow";
import { AlertColor } from "@mui/material";

export const useAlerts = () => {
    const { alerts, addAlert, deleteAlert } = useStoreSystem((state) => ({
        alerts: state.alerts,
        addAlert: state.addAlert,
        deleteAlert: state.deleteAlert,
    }), shallow);

    const addReadyAlert = (text: string, severity: AlertColor, delayTime = 5000, autoHide = true) => {
        const arrId = alerts.map((alert) => alert.id);
        const id = Math.max.apply(Math, arrId.length === 0 ? [0] : arrId) + 1;
        addAlert({ id, text, severity });

        if (autoHide) {
            Utils.delay(delayTime).then(() => deleteAlert(id));
        }
    };
    return { alerts, addReadyAlert };
};
